import {Avatar} from '@sollapay/ui/components';

import {RosterPopoverContent, RosterPopoverRow} from '@/components';
import {getInitials} from '@/utils/get-initials.utils';

import type {TrustAccountListSellerDTO} from '@sollapay/types';
import type {FC, ReactNode} from 'react';

export interface SellersRosterPopoverContentProps {
  sellers: Pick<TrustAccountListSellerDTO, 'id' | 'fullName' | 'idNumber'>[];
  title: ReactNode;
}

/** The sellers dropdown, shared by the list cell and the account header so they can't drift apart. */
export const SellersRosterPopoverContent: FC<SellersRosterPopoverContentProps> = ({
  sellers,
  title
}) => (
  <RosterPopoverContent title={title} count={sellers.length}>
    {sellers.map(seller => (
      <RosterPopoverRow
        key={seller.id}
        avatar={<Avatar initials={getInitials(seller.fullName)} seed={seller.id} noShadow />}
        name={seller.fullName}
        caption={seller.idNumber}
      />
    ))}
  </RosterPopoverContent>
);
